import { ResponsiveLine } from "@nivo/line";
import dayjs from "dayjs";
import { useMemo } from "react";

import { Typo } from "../../../Typo";
import { formatUSDWithoutSymbol } from "../utils/formatters";

type TradingChartMiniProps = {
  title: string;
  total: number;
  totalCurrencyCode?: string;
  data: { value: number; date: string }[];
  format?: (value: number) => string;
};

export const TradingChartMini = ({
  title,
  total,
  totalCurrencyCode,
  data,
  format,
}: TradingChartMiniProps) => {
  const chartData = useMemo(
    () => [
      {
        id: "volume",
        data: data.map((item) => ({
          x: dayjs(item.date).format("DD MMM"),
          y: item.value,
        })),
      },
    ],
    [data],
  );

  const displayValue = format ? format(total) : formatUSDWithoutSymbol(total);

  return (
    <div className="flex flex-row items-center justify-between">
      <div className="flex flex-col gap-1">
        <Typo type="labelSM" textColor="text-text-secondary">
          {title}
        </Typo>
        <div className="flex flex-row items-baseline gap-1">
          <Typo element="h4" type="headingMD" textColor="text-text-primary">
            {displayValue}
          </Typo>
          {totalCurrencyCode && (
            <Typo element="p" type="labelXS" textColor="text-text-tertiary">
              {totalCurrencyCode}
            </Typo>
          )}
        </div>
      </div>

      <div className="h-[49px] w-[64px]">
        <ResponsiveLine
          data={chartData}
          margin={{ top: 5, right: 5, bottom: 5, left: 5 }}
          xScale={{ type: "point" }}
          yScale={{
            type: "linear",
            min: "auto",
            max: "auto",
          }}
          axisTop={null}
          axisRight={null}
          axisBottom={null}
          axisLeft={null}
          enableGridX={false}
          enableGridY={false}
          enablePoints={false}
          colors={["rgba(107, 165, 252, 1)"]}
          lineWidth={2}
          useMesh={true}
          enableArea={true}
          areaOpacity={1}
          areaBlendMode="normal"
          defs={[
            {
              id: "miniGradientFill",
              type: "linearGradient",
              coordinates: [
                { x: 0, y: 0 },
                { x: 0, y: 1 },
              ],
              colors: [
                { offset: 0, color: "rgba(107, 165, 252, 0.4)" },
                { offset: 100, color: "rgba(107, 165, 252, 0)" },
              ],
            },
          ]}
          fill={[{ match: "*", id: "miniGradientFill" }]}
          isInteractive={false}
        />
      </div>
    </div>
  );
};
